<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rCZQ43/tc-custom/9781504083966.jpg?1705233287907" alt="This image is the cover for the book Emerald Decision"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Emerald Decision
      </h1>
      <p class="bookDescription body article font2">
        <b>In this <i>New York Times</i>–bestselling thriller, the son of a WWII spy delves into an explosive decades-old secret amid tensions between England and Ireland . . .</b><br/>  <br/> 1940: McBride, an Anglo-Irish spy, discovers a secret nest of Nazi submarines in Guernsey. As a minefield on the Irish coast is breached and German agents flow into the country—a desperate decision must be made in order to prevent the impending invasion in Britain. The consequences are deadly—and the story is kept top secret for decades . . .<br/>  <br/> 1980: McBride’s American son, an author, starts to dig into the history and mystery surrounding “the Emerald decision”—not realizing his own personal connection to it. And even after all these years, certain parties are willing to kill to keep the story a secret—or to exploit it . . .<br/>  <br/> “The great strength of [Thomas’s] books lies . . . in the presentation of powerfully exciting bouts of action in authentically realized settings.” —Reginald Hill, <i>Books and Bookmen</i><br/>  <br/><i>Originally published under the pseudonym David Grant</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Craig Thomas
      </h2>
      
      <p class="authorDescription body article">Craig Thomas was a Welsh author of thrillers, most notably the Mitchell Gant novels and the Kenneth Aubrey &amp; Patrick Hyde series. His best-known novel, <I>Firefox</I>, brought him to global prominence and was adapted into film, directed by and starring Clint Eastwood. One of the pioneering techno-thriller writers, his work is often compared to Tom Clancy. Thomas passed away in 2011 at the age of sixty-nine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MP
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?de1a31ae